import React from 'react';
import { sendError } from 'services/error-webhook';

class ErrorBoundary extends React.Component {
  componentDidCatch(error: any, errorInfo: any) {
    sendError(error, window.location.href, 'Não necessário');
  }

  render() {
    // eslint-disable-next-line react/destructuring-assignment
    return this.props.children;
  }
}
export default ErrorBoundary;
